<template>
  <div class="add-team-popup">
    <button class="close-x" @click="closePopup">
      <img class="close-icon" src="@/assets/images/close_icon.svg" alt="">
    </button>
    <header class="add-team-popup-header">
      <h2 class="title">
        {{ $t('ADD_TEAM_MEMBERS') }}
      </h2>
    </header>
    <add-members />
  </div>
</template>

<script>

import AddMembers from '@/components/add-members'
export default {
  name: 'staff-list-upload',
  components: { AddMembers },
  data () {
    return {

    }
  },

  computed: {

  },

  methods: {
    closePopup () {
      this.$router.push({ name: 'staffList' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-team-popup{
    $height: 120px;
    position: fixed; inset: 0; background-color: #fff; z-index: 10; max-height: 100vh; overflow: auto;
    padding-bottom: 10px;
    &-header{
      background-color: #F8FCFF; height: $height; line-height: $height; text-align: center;
      .title{
        font-size: 40px; font-weight: bold; color: #000;
      }
    }
  }
  /* width */
  ::-webkit-scrollbar {
    width: 6px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #f1f1f1;
    border-radius: 3px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #d1d1d1;
  }
</style>
